<template>
  <div class="section-sign-up-judge" id="section-sign-up-judge">
    <form-dynamix type="judge" :feedback="feedback" :loading="loading"
      :names="names" :models="models" :attributes="attributes"
      :vuelidate="$v"
      :is-print="isPrint"
      :is-print-pdf="isPrintPdf"
      @recaptcha="onRecaptcha"
      @send="onSend">
    </form-dynamix>
  </div>
</template>

<script type="text/javascript">
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageSubheader from '@/components/PageSubheader'
import FormDynamix from '@/components/FormDynamix'
import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import Site from '@/apis/Site'
import moment from 'moment'

// function validateArrayRequired (values) {
//   if (values && values.length > 0) {
//     var isChecked = false
//     for (var i = 0; i < values.length; i++) {
//       var value = values[i]
//       isChecked |= value
//     }
//     return isChecked
//   }
//   return false
// }
//
// function validateArrayOneNoneOrTwoThreeFour (values) {
//   if (values && values.length > 0) {
//     var noneSelected = false
//     var eitherOneSelected = false
//     if (values[1] === true) {
//       noneSelected = true
//     }
//     if (values[2] === true) {
//       eitherOneSelected = true
//     }
//     if (values[3] === true) {
//       eitherOneSelected = true
//     }
//     if (values[4] === true) {
//       eitherOneSelected = true
//     }
//     if (noneSelected && eitherOneSelected) {
//       return false
//     }
//   }
//   return true
// }

export default {
  name: 'section-sign-up-judge',
  mixins: [validationMixin],
  components: {
    DivContainer,
    DivColumns,
    PageSubheader,
    FormDynamix
  },
  props: ['is-print'],
  watch: {
    'isPrint': {
      handler: function (value, oldValue) {
        var isPrint = value
        if (isPrint) {
          this.models.signAt = ''
        } else {
          this.models.signAt = (moment(new Date())).format()
        }
      }
    },
    'models.kcbsCertified': {
      handler: function (value, oldValue) {
        var certified = value
        if (certified === 1) {
          this.attributes.kcbsNumber.disabled = false
          this.attributes.kcbsTotal.disabled = false
        } else {
          this.attributes.kcbsNumber.disabled = true
          this.attributes.kcbsTotal.disabled = true
        }
      },
      deep: true
    }
  },
  data: function () {
    return {
      isDesktop: true,
      isIE: EventBus.detectIE(),
      isPrintPdf: '/static/judge-application.pdf',
      items: [],
      names: [
        'name',
        'address', 'address2', 'city', 'state', 'zip', 'county',
        'email',
        'phone', 'phone2',
        // 'tshirt',
        'labelTshirt',
        'labelCheck', // label
        'kcbsCertified', 'kcbsNumber',
        'kcbsTotal',
        'masterJudge', 'tableCaptain',
        'kcbsLastThree',
        'last1', 'last2', 'last3',
        'labelTermsPre', // label
        'labelTerms', // label
        'signature', 'signAt',
        'signNote' // label
      ],
      models: {
        recaptcha: undefined,
        name: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        county: '',
        email: '',
        phone: '',
        phone2: '',
        tshirt: undefined,
        kcbsCertified: false,
        kcbsNumber: '',
        kcbsTotal: undefined,
        kcbsLastThree: [],
        last1: '',
        last2: '',
        last3: '',
        masterJudge: false,
        tableCaptain: false,
        signature: '',
        signAt: ''
      },
      attributes: {
        name: {
          title: 'Judge Applicant\'s Name'
        },
        // address: {
        //   type: 'textarea',
        //   title: 'Address',
        //   curLength: 0,
        //   maxLength: 500
        // },
        address: {
          title: 'Address 1'
        },
        address2: {
          title: 'Address 2'
        },
        city: {
          title: 'City',
          column: 'is-6'
        },
        state: {
          title: 'State',
          column: 'is-6'
        },
        zip: {
          title: 'Zip Code',
          column: 'is-6'
        },
        county: {
          title: 'County',
          column: 'is-6'
        },
        email: {
          title: 'Email'
        },
        phone: {
          title: 'Phone',
          column: 'is-6'
        },
        phone2: {
          title: 'Secondary Phone',
          column: 'is-6'
        },
        // tshirt: {
        //   type: 'dropdown',
        //   title: 'T-Shirt Size',
        //   options: [
        //     { value: undefined,
        //       title: 'T-shirt Size' },
        //     { value: 1, title: 'S' },
        //     { value: 2, title: 'M' },
        //     { value: 3, title: 'L' },
        //     { value: 4, title: 'XL' },
        //     { value: 5, title: '2XL' },
        //     { value: 6, title: '3XL' }
        //   ],
        //   note: 'Please select your size'
        // },
        labelTshirt: {
          type: 'label',
          note: `For T-SHIRT PRE-ORDER, contact our Judge Coordinator, Tim Lively.`
        },
        // labelCheck: {
        //   type: 'label',
        //   title: 'Applicant\'s Judging History:'
        // },
        kcbsCertified: {
          type: 'radio',
          title: 'KCBS Certified',
          options: [
            // { value: undefined,
            //   title: 'KCBS Certified' },
            { value: 1, title: 'Yes' },
            { value: 2, title: 'No' }
          ]
        },
        kcbsNumber: {
          title: 'KCBS CBJ Number',
          disabled: true,
          column: 'is-6'
        },
        kcbsTotal: {
          title: 'Total # of KCBS Events judged to date',
          disabled: true,
          column: 'is-6'
        },
        masterJudge: {
          type: 'radio',
          title: 'Master Judge',
          options: [
            // { value: undefined,
            //   title: 'Master Judge' },
            { value: 1, title: 'Yes' },
            { value: 2, title: 'No' }
          ]
        },
        tableCaptain: {
          type: 'radio',
          title: 'Certified Table Captain',
          options: [
            // { value: undefined,
            //   title: 'Certified Table Captain' },
            { value: 1, title: 'Yes' },
            { value: 2, title: 'No' }
          ]
        },
        kcbsLastThree: {
          type: 'checkbox',
          title: 'List the three (3) most recent contests you have judged:',
          options: []
        },
        last1: {
          title: '1.',
          column: 'is-10 is-offset-1'
        },
        last2: {
          title: '2.',
          column: 'is-10 is-offset-1'
        },
        last3: {
          title: '3.',
          column: 'is-10 is-offset-1'
        },
        labelTermsPre: {
          type: 'label',
          note: '<b>Waiver of Liability:</b> In consideration of your accepting this entry, I, the undersigned, intending to be legally bound, hereby for myself, my heirs, executors and administrators, waive and release any and all rights and claims for damages that I may have against The Boss Hog Cook-off, The Downtown Organization of Retailers, First National Bank of Waynesboro, Georgia; The City of Waynesboro; Mr. Golf Carts, Inc.; The Kansas City Barbecue Society, or any individual or group responsible for the organization or management of The Boss Hog Cook-off.  I hereby grant permission for The Boss Hog Cook-off and/or agents authorized by them to use any photographs, videotapes, motion pictures, recordings, and any other record of this event for any legitimate purpose.  I agree to abide by the rules and regulations of The Boss Hog Cook-off and Kansas City Barbecue Society.<br />' +
          '<b>Conditions:</b> The Boss Hog Cook-Off Committee reserves the right to reject any application. If your application is not accepted, your money will be refunded. However, no refunds of the application fee will be made once you have been accepted into the contest. Any photographs or videos taken of your team on-site become the property of D.O.O.R. and may be used for promotional purposes. By signing the application, contestants agree to indemnify and hold D.O.O.R., the Boss Hog Committee, the City of Waynesboro, Mr. Golf Carts Inc., and all employees, agents and volunteers, harmless from any and all claims made against same; including without limitation, all costs, liabilities, judgments, expenses, damages or reasonable attorneys’ fees, arising out of, or in connection with; (1) any structure erected by Contestant; (2) any apparatus, equipment or personal property used by Contestant; (3) any act or omission to act of Contestant, its agents, invitees, participants, representatives, employees, servants, and assigns; and (4) any claims made on account or resulting from contestants participating in the contest.<br />' +
          '<b>Participant’s Agreement:</b> The undersigned agrees that he/she will be responsible for any loss or damage to his/her work during Boss Hog. He/She agrees to abide by all rules as set forth by Boss Hog and KCBS. My signature below and enclosed amount due/mailed payment indicate that I understand that failure to abide by these rules and regulations may result in the termination of my contract and my participation in future events with D.O.O.R. This is a rain or shine festival, and no refund will be given due to weather.<br />' +
          '<b>Parking Agreement:</b> ONLY ONE VEHICLE ALLOWED PER TEAM COOK SITE.  Due to the overwhelming growth of our event, we need as much parking for patrons as possible.  Therefore, any vehicle OR trailer in excess of ONE must park in the designated area.  Parking Passes will be given for the team vehicles to be placed in the front window – towing will be enforced at the owner’s expense.  Thank you for understanding!'
        },
        labelTerms: {
          type: 'label',
          note: `Please complete this form or mail it to Tim Lively at 411 Claxton-Lively Road, Waynesboro, GA 30830. If you have any questions, please call Tim Lively at (706) 551-2045. Thank you for your interest in the ${EventBus.info.xth} Boss Hog Cook-Off. A representative will contact you soon about your judging status.`
        },
        signature: {
          title: 'Applicant\'s Name',
          column: 'is-6'
        },
        signAt: {
          title: 'Date',
          column: 'is-6',
          disabled: true
        },
        signNote: {
          null: true,
          title: 'Note',
          column: 'is-12',
          note: '* By typing your name, you agree to the above.<br />' +
          `* By typing your name and submitting this Judge Application, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations enforced locally as well as any KCBS guidelines/addendums that may arise.`
        }
      },
      // captcha: '',
      // captchaImage: undefined,
      // session: '',
      feedback: false,
      loading: false,
      navEmail: EventBus._data._navEmail
    }
  },
  validations: {
    models: {
      recaptcha: { required },
      name: { required },
      // address: { required, maxLength: maxLength(500) },
      address: { required, maxLength: maxLength(500) },
      address2: { maxLength: maxLength(500) },
      city: { required, maxLength: maxLength(191) },
      state: { required, maxLength: maxLength(191) },
      zip: { required, maxLength: maxLength(191) },
      county: { required },
      email: { required, email, minLength: minLength(4) },
      phone: { required },
      phone2: {},
      // tshirt: { required },
      labelTshirt: {}, // label
      kcbsCertified: { required },
      kcbsNumber: {},
      kcbsTotal: {},
      kcbsLastThree: {},
      last1: {},
      last2: {},
      last3: {},
      masterJudge: { required },
      tableCaptain: { required },
      labelTermsPre: {}, // label
      labelTerms: {}, // label
      signature: { required },
      signAt: { required },
      signNote: {}
    }
  },
  created: function () {
    // console.log('-- creating... --')
    // console.log(this.$v)
    // console.log(this.models)
    // this.init()
  },
  mounted: function () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    // this.onRecaptcha(data => {
    //   // console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    if (this.isPrint) {
      this.models.signAt = ''
    } else {
      this.models.signAt = (moment(new Date())).format()
    }

    // console.log('-- mounting... --')
    // console.log(this.$v)
  },
  methods: {
    onRecaptcha: function (info) {
      if (info && info.status) {
        this.models.recaptcha = (info.status === 'ok' ? info.response : undefined)
        if (info.status !== 'ok') {
          console.log('FormDynamix:recaptcha():' + info.status)
        }
      }
    },

    onClear: function () {
      // this.models.recaptcha = undefined
      this.models.name = ''
      this.models.address = ''
      this.models.address2 = ''
      this.models.city = ''
      this.models.state = ''
      this.models.zip = ''
      this.models.county = ''
      this.models.email = ''
      this.models.phone = ''
      this.models.phone2 = ''
      this.models.tshirt = undefined
      this.models.kcbsCertified = undefined
      this.models.kcbsNumber = ''
      this.models.kcbsTotal = ''
      this.models.kcbsLastThree = []
      this.models.last1 = ''
      this.models.last2 = ''
      this.models.last3 = ''
      this.models.masterJudge = undefined
      this.models.tableCaptain = undefined
      this.models.signature = ''
      this.models.signAt = (moment(new Date())).format()
    },

    onSendDisabled: function () {
      var _self = this
      _self.feedback = 'We are sorry, all judging spots are full.'
      return
    },

    onSend: function (formInfo) {
      // $v.models.$touch()
      var _self = this
      console.log('SignUpTeamSection:onSend(): $v / models')
      console.log(formInfo)

      // var models = formInfo.models
      if (formInfo.vuelidate.$invalid) {
        _self.feedback = 'Form contains errors, please recheck.'
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        return
      }

      if (!this.models.recaptcha) {
        _self.feedback = 'Invalid recaptcha, please validate again.'
        return
      }
      _self.feedback = false

      var models = formInfo.models

      console.log('-- send form --')
      console.log(models)
      console.log(models.name)
      console.log(models.address)
      console.log(models.address2)
      console.log(models.city)
      console.log(models.state)
      console.log(models.zip)
      console.log(models.county)
      console.log(models.email)
      console.log(models.phone)
      console.log(models.phone2)
      console.log(models.tshirt)
      console.log(models.kcbsCertified)
      console.log(models.kcbsNumber)
      console.log(models.kcbsTotal)
      console.log(models.last1)
      console.log(models.last2)
      console.log(models.last3)
      console.log(models.masterJudge)
      console.log(models.tableCaptain)
      console.log(models.signature)
      console.log(models.signAt)

      // if (formInfo) {
      //   return
      // }

      _self.loading = true
      Site.signUpJudge(
        models.recaptcha,
        models.name,
        models.address,
        models.address2,
        models.city,
        models.state,
        models.zip,
        models.county,
        models.email,
        models.phone,
        models.phone2,
        models.tshirt,
        models.kcbsCertified,
        models.kcbsNumber,
        models.kcbsTotal,
        models.last1,
        models.last2,
        models.last3,
        models.masterJudge,
        models.tableCaptain,
        models.signature,
        models.signAt
      )
      .then(data => {
        _self.loading = false

        // invalid captcha
        if (data && data.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.'
          return
        }

        // invalid captcha
        if (data && data.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please re-type again.'
          return
        }

        if (data && data.status !== 'ok') {
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
          return
        }

        this.$v.models.$reset()
        this.onClear()

        // _self.captcha = ''
        // _self.session = '' // open up to maintain session

        // _self.$toast.open({
        //   message: 'We will be contacting you via email or phone. Thanks!',
        //   position: 'is-bottom',
        //   type: 'is-success'
        // })
        _self.feedback = 'Your application has been successfully submitted. Thank you!'
      })
      .catch(error => {
        console.log('invalid email', error)
        // this.error = error.error
        console.log(error)
        // _self.captcha = ''

        // invalid captcha
        if (error && error.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.'
          _self.loading = false
          return
        }

        // invalid captcha
        if (error && error.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please retype again.'
          _self.loading = false
          return
        }

        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
        _self.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.section-sign-up-judge {
  // padding: 1rem 0;
  // margin-top: 4em;
  // margin-bottom: 3em;
  padding: 1rem 0.75rem;
  // -webkit-print-color-adjust: exact;
}
</style>



// WEBPACK FOOTER //
// SignUpJudgeSection.vue?dcf98d38